export const SUBSCRIPTION_STATUSES = Object.freeze({
  subscribed: 'SUBSCRIBED',
  trial: 'TRIAL',
  preview: 'PREVIEW',
  cancelled: 'CANCELLED',
  expired: 'EXPIRED',
  expiredFromCancel: 'EXPIRED_FROM_CANCEL'
});

export default { SUBSCRIPTION_STATUSES };
